import { render, staticRenderFns } from "./AdminScore.vue?vue&type=template&id=5a552b6b&scoped=true&"
import script from "./AdminScore.vue?vue&type=script&lang=js&"
export * from "./AdminScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a552b6b",
  null
  
)

export default component.exports